import { render, staticRenderFns } from "./PasswordUpdate.vue?vue&type=template&id=5b6b8a12&scoped=true&"
import script from "./PasswordUpdate.vue?vue&type=script&lang=ts&"
export * from "./PasswordUpdate.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordUpdate.vue?vue&type=style&index=0&id=5b6b8a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6b8a12",
  null
  
)

export default component.exports